var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStorage = function SvgStorage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.714,
    d: "M.857 7.857h22.286V22.43a.857.857 0 0 1-.857.857H1.714a.857.857 0 0 1-.857-.857zM.857 7.857A6.857 6.857 0 0 1 7.714 1h8.572a6.857 6.857 0 0 1 6.857 6.857"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.714,
    d: "M18.857 23.286v-9.429A.857.857 0 0 0 18 13H6a.857.857 0 0 0-.857.857v9.429M5.143 16.429h13.714M5.143 19.857h13.714"
  })));
};
export default SvgStorage;